import createFieldsFromTags from '../util/createFieldsFromTags'

export interface ContentSection {
  title?: string
  handle?: string
  cmsSyncSource?: string
  contentHtml?: string
  contentType?: string
  tags?: string[]
  [key: string]: any
}

export const mapContentSections = (
  sections: string | ContentSection[],
  cmsSyncSource: string
): ContentSection[] => {
  const formattedSections =
    typeof sections === 'string' ? JSON.parse(sections) : sections

  if (Array.isArray(formattedSections)) {
    return formattedSections.map(section => {
      if (section.tags) {
        const fieldTags = createFieldsFromTags(section.tags)

        return {
          ...section,
          ...fieldTags,
          cmsSyncSource
        }
      }

      return {
        ...section,
        cmsSyncSource
      }
    })
  }

  return []
}
